import type { ApolloLink, Operation } from "@apollo/client";
import executeGraphLink from "../links/executeGraphLink";
import { getMailboxInfoFromOperationStrict } from "owa-request-options";
import { type ResolverImports } from "../factories/createGraphServerLink";

export function isPstFileOperation(operation: Operation): boolean {
    const mailboxInfo = getMailboxInfoFromOperationStrict(operation);
    return mailboxInfo?.type === "PstFile";
}

export function pstServerLink(context: Record<string, any>, getResolvers: () => Promise<ResolverImports>): ApolloLink {
    async function getResolversProfile() {
        const resolverImports = await getResolvers();
        
        const resolvers = resolverImports.pst || {};
        const dataSource = undefined;
        const isOfflineEnabled = !!resolverImports.offline;
        
        return {
            resolvers,
            dataSource,
            isOfflineEnabled,
        };
    }
    
    return executeGraphLink(getResolversProfile, context);
}
